/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { CustomFieldDestroyPathParams, CustomFieldDestroyResponse } from '../types/CustomFieldDestroy'

/**
 * DELETE /:organisation/custom_fields/:field
 * @see backend/nexus/modules/CustomField/Http/Controllers/CustomFieldController.php CustomFieldController::destroy
 */
export async function customFieldDestroy(
	organisation: CustomFieldDestroyPathParams['organisation'],
	field: CustomFieldDestroyPathParams['field'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CustomFieldDestroyResponse>> {
	return axiosInstance.delete(`/${organisation}/custom_fields/${field}`, config)
}
